import React from "react";
import "./UpdateItem.scss";

const UpdateSection = ({ title, children }) => (
  <div className="UpdateSection">
    <h4>{title}</h4>
    {children}
  </div>
);

const UpdateItem = ({ version, released, features, sections }) => (
  <div className="UpdateItem">
    <div className="left">
      <div className="head">
        <h2>Version {version}</h2>
        <h6>Released {released}</h6>
      </div>
      {features &&
        features.map((feature, i) => (
          <h4 key={i}>
            <strong>{feature.topic} - </strong>
            {feature.description}
          </h4>
        ))}
    </div>
    <div className="right">
      {sections &&
        sections.map((section, i) => (
          <UpdateSection key={i} title={section.title}>
            <ul>
              {section.items &&
                section.items.map((item, j) => <li key={j}>{item}</li>)}
            </ul>
          </UpdateSection>
        ))}
    </div>
  </div>
);

export default UpdateItem;
